import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcCylinder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 49,
	height: 49,
	viewBox: "0 0 49 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1681_24567)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M20.5603 24.2994V5.09961H29.6366V24.2994L44.2984 41.0993V49.0992H5.89844V41.0993L20.5603 24.2994Z",
				fill: "#B7D8F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.3166 33.1006H12.8803L5.89844 41.1005V49.1004H44.2984V41.1005L37.3166 33.1006Z",
				fill: "#8C81F7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.8984 12.2998H26.6984",
				stroke: "#8C81F7",
				strokeWidth: 1.59999
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0977 7.50053V1.10059H33.0977V7.50053H17.0977Z",
				fill: "#8C81F7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.8984 16.3008H25.0984",
				stroke: "#8C81F7",
				strokeWidth: 1.59999
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.8984 21.1006H26.6984",
				stroke: "#8C81F7",
				strokeWidth: 1.59999
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1681_24567",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white",
			transform: "translate(0.5 0.5)"
		})
	}) })]
});
export default SvgIcCylinder;
